import { Reducer } from "../../lib/redux";
import { DriverChangesActionTypes } from "./types";
import { IDriverChange } from "../../model/DriverChangeLog";
import { DriverChangeActions } from "./actions";
import { extend } from "../../utils/vanilla";

export let defaultDriverChanges: IIdDictionary<IDriverChange[]> = {};

export let driverChanges: Reducer<IIdDictionary<IDriverChange[]>, DriverChangeActions> = (state = defaultDriverChanges, action) => {
    switch (action.type) {
        case DriverChangesActionTypes.SET_DRIVER_CHANGES:
            if (action.payload.userId) {
                return {
                    ...state,
                    [action.payload.userId]: extend(true, [], action.payload.driverChanges)
                };
            }
            return state;
        case DriverChangesActionTypes.CLEAR_DRIVER_CHANGES:
            if (action.payload) {
                let newState = {...state};
                delete newState[action.payload];
                return newState;
            }
            return defaultDriverChanges;
        default:
            return state;
    }
};